<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">



                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                                <div style="min-height: 500px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <app-sub-header title="Edit Event"></app-sub-header>


                                            <div class="form-group">
                                                <!-- <label for="comment">Alert Title</label> -->
                                                <textarea maxlength="50" class="form-control"
                                                    formControlName="eventName" placeholder="Event Name" rows="2"
                                                    [ngClass]="{ 'is-invalid': submitted && f.eventName.errors }">
                                                   </textarea>
                                                <div style="text-align: right;" class="margin-b">
                                                    <p style="margin-bottom: -1rem;" class="small error">
                                                        {{f.eventName.value?.length || 0}}/50</p>
                                                </div>

                                                <div *ngIf="submitted && f.eventName.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.eventName.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <!-- <label for="comment">Alert Title</label> -->
                                                <input type="text" placeholder="Datepicker" class="form-control"
                                                    formControlName="validFrom" bsDatepicker placeholder="Start event"
                                                    [(ngModel)]="model"
                                                    [ngClass]="{ 'is-invalid': submitted && f.validFrom.errors }">

                                                <div *ngIf="submitted && f.validFrom.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.validFrom.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>

                                            </div>



                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">


                                                <input type="text" placeholder="End event" class="form-control"
                                                    formControlName="validTill" bsDatepicker [(ngModel)]="modelSecond"
                                                    [ngClass]="{ 'is-invalid': submitted && f.validTill.errors }">
                                                <div *ngIf="submitted && f.validTill.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.validTill.errors.required">
                                                        {{errorMessage}}</div>
                                                    <div *ngIf="f.validTill?.errors?.error">End event date cannot
                                                        earlier
                                                        than Event start date.</div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <!-- <label for="comment">Alert Title</label> -->
                                                <textarea maxlength="50" class="form-control"
                                                    formControlName="locationName" placeholder="Location" rows="2">
                                                   </textarea>
                                                <div style="text-align: right;" class="margin-b">
                                                    <p style="margin-bottom: -1rem;" class="small error">
                                                        {{f.locationName.value?.length || 0}}/50</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">

                                                <input type="text" class="form-control" ngx-google-places-autocomplete
                                                    (onAddressChange)="AddressChange($event)" placeholder="Address"
                                                    [(ngModel)]="address" [ngModelOptions]="{standalone: true}"
                                                    [ngClass]="{ 'is-invalid': submitted && f.address.errors }">


                                                <input type="hidden" formControlName="address" >


                                                <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.address.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <!-- <label for="comment">Description</label> -->
                                                <textarea maxlength="250" class="form-control"
                                                    formControlName="description" placeholder="Description" rows="5"
                                                    [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                                <div style="text-align: right;" class="margin-b">
                                                    <p style="margin-bottom: -1rem;" class="small error">
                                                        {{f.description.value?.length || 0}}/250</p>
                                                </div>
                                                <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                                    <div style="text-align: right;"
                                                        *ngIf="f.description.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row margin-b">

                                        <div class="col-md-12">
                                            <div class="form-group">

                                                <button type="button" (click)="open(content)"
                                                    class="btn btn-style color main-backgroundcolor">
                                                    Add Event Photo </button>

                                                <input type="hidden" formControlName="photo"
                                                    [ngClass]="{ 'is-invalid': submitted && f.photo.errors }">

                                                <div *ngIf="submitted && f.photo.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.photo.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>


                                    <div *ngIf="showImage" class="row margin-b">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <div class="image-wrapper" style="width: 100%; height:150px;">
                                                    <img [src]="eventImage" style="width: 100%; height:150px;">
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input margin-t" type="checkbox"
                                                        (change)="check($event,'visitors')" id="inlineCheckbox1"
                                                        value=false formControlName="notifyVisitors">
                                                    <label class="form-check-label margin-l"
                                                        for="inlineCheckbox1">Notify
                                                        followers about this event
                                                        Select
                                                        day before the event begins.</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">

                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input margin-t" type="checkbox"
                                                        (change)="check($event,'attendees')" id="inlineCheckbox1"
                                                        value=false formControlName="notifyAttenders">
                                                    <label class="form-check-label margin-l"
                                                        for="inlineCheckbox1">Notify
                                                        visitors about this event
                                                        Select
                                                        hours before the event begins.</label>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div *ngIf="showDays" class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <select class="form-control" formControlName="notifyVisitorsBefore"
                                                    id="sel1">
                                                    <option value="">Select Dates</option>
                                                    <option *ngFor="let props of datesArray" [value]="props">
                                                        {{props}}
                                                    </option>

                                                </select>
                                            </div>
                                        </div>

                                    </div>

                                    <div *ngIf="showhours" class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <select class="form-control" formControlName="notifyAttenderBefore"
                                                    id="sel1">
                                                    <option value="">Select hours</option>
                                                    <option *ngFor="let props of hourArray" [value]="props">
                                                        {{props}}
                                                    </option>

                                                </select>
                                            </div>
                                        </div>

                                    </div>


                                    <div class="row">
                                        <div class="col">
                                            <select class="btn11 form-control"
                                                [ngClass]="{ 'is-invalid': submitted && f.accessibility.errors }"
                                                formControlName="accessibility">
                                                <option value="">Select Privacy Setting</option>
                                                <option value="public">Public</option>
                                                <option value="affiliated">Affiliates only</option>
                                                <option value="followers">Affiliates and followers </option>
                                            </select>
                                            <div *ngIf="submitted && f.accessibility.errors" class="invalid-feedback">
                                                <div style="text-align: right;" *ngIf="f.accessibility.errors.required">
                                                    {{errorMessage}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    



                                    <br>
                                    <button type="submit"
                                        class="btn color btn-lg btn-block main-backgroundcolor">Update</button>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>




<ng-template #content let-modal>
    <div class="modal-header main-backgroundcolor color">
        <h4 class="modal-title" id="modal-basic-title ">Select Image</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span class="color" aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">

        <div *ngIf="!loading" class="grid-container">
            <div class="grid-item" *ngFor="let props of gallaryArr; let i = index">
                <div class="image-wrapper">
                </div>
            </div>


        </div>



        <div *ngIf="loading" class="grid-container">
            <div class="grid-item" *ngFor="let props of gallaryArr; let i = index">
                <div class="image-wrapper">
                    <img class="zoom" [ngClass]="{'selected': selectedItem == i}" [src]="props.url"
                        (error)="getErrorImage($event)" (click)="selectImage(props,i)">
                </div>
            </div>


        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn main-backgroundcolor color"
            (click)="modal.close('Save click');addimageForm()" >Select</button>
    </div>
</ng-template>